import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoginServicesService } from '../shared/services/login-services.service';
// import * as $ from 'jquery';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { AppService } from '../shared/services/app.service';
declare var $: any;

@Component({
  selector: 'app-forgotpassword',
  templateUrl: './forgotpassword.component.html',
  styleUrls: ['./forgotpassword.component.scss'],
})
export class ForgotpasswordComponent implements OnInit {
  language: any = 'en';
  languages: any = [
    { short: 'en', fullform: 'English' },
    { short: 'jp', fullform: 'Japanese' },
  ];
  register: any = {
    firstname: '',
    lastname: '',
    emailId: '',
    organization: '',
    password: '',
    confirmPassword: '',
    verified: '',
    groupToken: '',
  };
  toastMsg: any = '';

  constructor(
    public translate: TranslateService,
    private router: Router,
    private loginService: LoginServicesService,
    private cookieService: CookieService,
    private appService: AppService
  ) {
    translate.setDefaultLang('en');
    this.cookieService.delete('language');
    this.cookieService.set('language', this.language);
    const browserLang = translate.getBrowserLang();
    translate.use(browserLang.match(/en|jp/) ? browserLang : 'en');
  }

  ngOnInit(): void { }

  updateLanguage(lang: any) {
    this.cookieService.delete('language');
    this.cookieService.set('language', lang);
  }

  resetPassword(username: any) {
    if (username) {
      let emailId = { username: username };
      this.loginService.resetPassword(emailId).subscribe((response: any) => {
        if (response.statusCode === 200) {
          this.triggerToast(this.appService.getResourceText('B011'));
        } else if (response.statusCode === 208) {
          this.triggerToast(this.appService.getResourceText('B012'));
        } else if (response.statusCode === 500) {
          this.triggerToast(this.appService.getResourceText('B002'));
        } else {
          this.triggerToast(this.appService.getResourceText('B002'));
        }
      });
    } else {
      this.triggerToast(this.appService.getResourceText('V017'));
    }
  }

  triggerToast(message: string) {
    this.toastMsg = message;
    $('#snackbar').html(message);
    var x: any = document.getElementById('snackbar');
    x.className = 'show';
    setTimeout(function () {
      x.className = x.className.replace('show', '');
    }, 3000);
  }

  backToLogin() {
    this.router.navigateByUrl('/login');
  }
}
